import { useState, useEffect } from 'react';
import { request } from '../../shared/services/api';

let cachedSignActive: boolean | null = null;

/**
 * Hook que indica si M15 V·IANet Sign está activo para el tenant actual.
 * Cachea el resultado en memoria para evitar requests repetidos.
 */
export function useSignMode(): { signActive: boolean; loading: boolean } {
  const [signActive, setSignActive] = useState(cachedSignActive ?? false);
  const [loading, setLoading] = useState(cachedSignActive === null);

  useEffect(() => {
    if (cachedSignActive !== null) {
      setSignActive(cachedSignActive);
      setLoading(false);
      return;
    }
    request<{ data: { signActive: boolean } }>('/sign/mode')
      .then((res) => {
        cachedSignActive = res.data.signActive;
        setSignActive(res.data.signActive);
      })
      .catch(() => {
        cachedSignActive = false;
        setSignActive(false);
      })
      .finally(() => setLoading(false));
  }, []);

  return { signActive, loading };
}
